import React from "react";
import { Typography } from "@mui/material";
import CustomDataGrid from "../../CustomDataGrid";
import { Box } from "@mui/material";

const HistoriaClinicaTab = ({ dataRows }) => {
  const columnsObject = [
    { field: "fecha", headerName: "Fecha", flex: 0.8 },
    { field: "centro", headerName: "Clínica", flex: 1 },
    { field: "especialidad", headerName: "Especialidad", flex: 1.2 },
    {
      field: "odontologo",
      headerName: "Odontólogo",
      flex: 1.2,
      textTransform: "capitalize",
    },
    { field: "codigo_nomenclador", headerName: "Código", flex: 0.6 },
    { field: "pieza", headerName: "Pieza", flex: 0.5 },
    { field: "caras", headerName: "Caras", flex: 0.5 },
    { field: "auditoria", headerName: "Aud.", flex: 0.5 },
    {
      field: "notas",
      headerName: "Notas",
      flex: 2,
      wrap: true,
      renderCell: (params) => (
        <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
          {params.value.toString().toLowerCase()}
        </div>
      ),
    },
  ];

  return (
    <Box>
      <CustomDataGrid
        columnsObject={columnsObject}
        dataRows={dataRows}
        sortField="fecha_usa"
        sortOrder="desc"
        dynamicRowHeightField="notas"
        columnPercentage={0.4}
      />
    </Box>
  );
};

export default HistoriaClinicaTab;
